// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"181":"21d906bd","368":"59b3d997","481":"116125b7","521":"6e913679","595":"2c86e176","710":"7b52ccce","767":"6f80a87c","787":"f1de937d","797":"60793596","818":"da13d589","945":"8db71563","994":"52edb166"}[chunkId] + ".chunk.js";
};